<template>
    <div id="app"
         class="App">
        <header-component></header-component>
        <sidebar-component></sidebar-component>
        <keep-alive>
            <router-view/>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
            'HeaderComponent': () => import(/* webpackChunkName: "Header" */ '@/components/shell/Header'),
            'SidebarComponent': () => import(/* webpackChunkName: "Sidebar" */ '@/components/shell/Sidebar')
        }
    }
</script>

<style lang="scss">
    @import './scss/main';

    .App {
        width: auto;
        margin-left: 0;

        @media (min-width: 769px) {
            margin-left: 225px;
        }

        @media (min-width: 940px) {
            margin-left: 325px;
        }
    }
</style>
